exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-sidenav[data-v-7050e704] {\n  display: none;\n  height: 100%; /* 100% Full-height */\n  width: 60%; /* 0 width - change this with JavaScript */\n  position: fixed; /* Stay in place */\n  z-index: 1; /* Stay on top */\n  top: 0; /* Stay at the top */\n  left: 0;\n  background-color: #ECEFF1; /* Black*/\n  overflow-x: hidden; /* Disable horizontal scroll */\n  -webkit-transition: 0.5s;\n  transition: 0.5s; /* 0.5 second transition effect to slide in the sidenav */\n}\n.active-side-menu[data-v-7050e704] {\n  display: block;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-7050e704","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/user/Index.vue
// module id = 1794
// module chunks = 0